
import Vue from 'vue'
import Router from 'vue-router'

import Editor from '@/components/Editor/Editor'
import Gallery from '@/components/Gallery/Gallery'
import HomeBackup from '@/components/Home/HomeBackup'
import Home from '@/components/Home/Home'
import Recursos from '@/components/Home/Recursos'
import Ganadores2019 from '@/components/Home/Ganadores2019'
import User from '@/components/User/User'
import UserSettings from '@/components/User/UserSettings'
import Embed from '@/components/Embed/Embed'
import ClassroomDetail from '@/components/User/ClassroomDetail'
import ProjectPlayer from '@/components/ProjectPlayer/ProjectPlayer'
import Mando from '@/components/ProjectPlayer/Mando'
import LoginFullPage from '@/components/Login/LoginFullPage'
import ResetPassword from '@/components/Login/ResetPassword'
import ResetPasswordConfirm from '@/components/Login/ResetPasswordConfirm'
import VerifyEmail from '@/components/Login/VerifyEmail'
import store from '../store/store.js'

Vue.use(Router)

const redirectLogout = (to, from, next) => {
  store.dispatch('auth/logout')
    .then(() => next('/'))
}

const requireAuthenticated = (to, from, next) => {
  store.dispatch('auth/initialize')
    .then(() => {
      if (!store.getters['auth/isAuthenticated']) {
        next('/login')
      } else {
        next()
      }
    })
}

const requireNotAuthenticated = (to, from, next) => {
  store.dispatch('auth/initialize')
    .then(() => {
      if (store.getters['auth/isAuthenticated']) {
        next('/user')
      } else {
        next()
      }
    })
}

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      redirect: { name: 'Home' }
    },
    {
      path: '/login2',
      name: 'login2',
      component: LoginFullPage,
      props: true
    },
    {
      path: '/login',
      name: 'login',
      component: LoginFullPage,
      props: { isLogin: true },
      beforeEnter: requireNotAuthenticated
    },
    {
      path: '/register',
      name: 'register',
      component: LoginFullPage,
      props: { isLogin: false },
      beforeEnter: requireNotAuthenticated
    },
    {
      path: '/classroom/:classid',
      name: 'classroom',
      component: ClassroomDetail,
      props: true,
      beforeEnter: requireAuthenticated
    },
    {
      path: '/editor',
      name: 'Editor',
      component: Editor
    },
    {
      path: '/editor/create',
      name: 'Editor.create',
      component: Editor,
      props: true
    },
    {
      path: '/editor/created',
      name: 'Editor.created',
      component: Editor,
      props: true
    },
    {
      path: '/editor/example/:exampleType/:exampleId',
      name: 'Editor.example',
      component: Editor,
      props: true
    },
    {
      path: '/editor/:projectId',
      name: 'Editor.load',
      component: Editor,
      props: true
    },
    {
      path: '/editor/clone/:projectId',
      name: 'Editor.clone',
      component: Editor,
      props: true
    },
    {
      path: '/embed/', // ':projectId',
      name: 'Embed',
      component: Embed
      // props: true
    },
    {
      path: '/gallery',
      redirect: { name: 'Gallery', params: { page: 1 } }
    },
    {
      path: '/gallery/:page',
      name: 'Gallery',
      component: Gallery
    },
    {
      path: '/verify-email/:emailkey',
      name: 'verifyemail',
      component: VerifyEmail,
      props: true
    },
    {
      path: '/user/',
      name: 'User',
      component: User,
      beforeEnter: requireAuthenticated
    },
    {
      path: '/user/settings/',
      name: 'usersettings',
      component: UserSettings,
      beforeEnter: requireAuthenticated
    },
    {
      path: '/resetpassword',
      name: 'resetPassword',
      component: ResetPassword
    },
    {
      path: '/reset/:uid/:token/',
      name: 'resetPasswordConfirm',
      component: ResetPasswordConfirm,
      props: true
    },
    /*
    {
      path: '/user/projects',
      component: MyProjectList,
      beforeEnter: requireAuthenticated
    },
    */
    {
      path: '/homebackup',
      name: 'HomeBackup',
      component: HomeBackup
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/recursos',
      name: 'Recursos',
      component: Recursos
    },
    {
      path: '/top2019',
      name: 'ganadores2019',
      component: Ganadores2019
    },
    {
      path: '/mando',
      name: 'Mando',
      component: Mando
    },
    {
      path: '/projectplayer',
      name: 'ProjectPlayer',
      component: ProjectPlayer,
      props: route => ({ ...route.params, ...route.query })
    },
    {
      path: '/logout',
      beforeEnter: redirectLogout
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {selector: to.hash}
    } else {
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js